import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function AboutPreviewSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-brand-black py-28 md:py-40 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-gold/3 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        {/* Quotation mark */}
        <div className="reveal mb-6">
          <span
            className="font-display text-gold/20 font-black leading-none select-none"
            style={{ fontSize: "8rem" }}
          >
            &ldquo;
          </span>
        </div>

        <div className="reveal reveal-delay-1 -mt-12">
          <span className="inline-block text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase mb-8">
            About The Agency
          </span>
          <p className="font-display text-white text-2xl md:text-3xl leading-relaxed font-medium mb-10">
            The{" "}
            <span className="text-gradient-gold font-bold">
              LittyCity Agency LLC
            </span>
            , founded in 2024, blends creativity, structure, and community to
            help creators grow authentically while monetizing their talent.
          </p>
        </div>

        <div className="reveal reveal-delay-2">
          <Link
            to="/about"
            className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full border border-gold text-gold font-sans text-sm font-medium tracking-wider hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap group"
          >
            Learn More About Us
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  );
}
